<template>
    <div :class="{'reverse': !reverse}"
         :style="'--current-color: '+currentColor+'; --current-bg-color: '+currentBgColor+';'">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "pill",
        props: {
            color: {
                type: String,
                default: "color-white"
            },
            bgColor: {
                type: String,
                default: "color-primary"
            },
            reverse: {
                type: Boolean,
                default: true
            }
        },

        computed: {
            currentColor() {
                if (this.color === "pill-danger") {
                    return "#FF5630"
                } else if (this.color === "pill-warning") {
                    return "#FFAB00"
                } else if (this.color === "pill-success") {
                    return "#36B37E"
                } else {
                    return "#FFF"
                }
            },
            currentBgColor() {
                if (this.bgColor === "pill-danger") {
                    return "#FF5630"
                } else if (this.bgColor === "pill-warning") {
                    return "#FFAB00"
                } else if (this.bgColor === "pill-success") {
                    return "#36B37E"
                } else {
                    return "#0065FF"
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    div {
        font-size: 12px;
        width: auto;
        padding: 2px 8px;
        text-align: center;
        border-radius: 16px;
        color: var(--current-color);
        background: var(--current-bg-color);


        &.reverse {
            color: var(--current-bg-color);
            background: var(--current-color);
            border: 1px solid var(--current-bg-color);
            cursor: pointer;
            transition: all .3s ease;

            &:hover {
                color: var(--current-color);
                background: var(--current-bg-color);
            }
        }
    }
</style>
